import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { EBrandMenuItem } from '../../enums';
import { BrandMenuItem } from '../BrandMenuItem';

import { IBrandMenuProps, IBrandMenuState } from './types';

import * as s from './BrandMenu.scss';

@Translate('common.containers.Brand.components.BrandMenu')
export class BrandMenu extends React.Component<IBrandMenuProps, IBrandMenuState> {

	onMenuItemClick = (id: EBrandMenuItem) => {
		const {
			onSelect,
		} = this.props;

		onSelect(id);
	};

	render() {
		const {
			activeMenuItem,
			lastMenuItemRef,
			className,
			hideThresholds,
		} = this.props;

		return (
			<div className={cn(s.block, className)}>
				{Object.values(EBrandMenuItem).map((menuItem: EBrandMenuItem, index, items) => (
					<BrandMenuItem
						key={menuItem}
						id={menuItem}
						isActive={activeMenuItem === menuItem}
						title={this.t(menuItem)}
						hideThreshold={hideThresholds ? hideThresholds[menuItem] : null}
						blockRef={items.length === index + 1 ? lastMenuItemRef : null}
						onClick={this.onMenuItemClick}
					/>
				))}
			</div>
		);
	}

}
